export default {
  API_ENDPOINT: "https://floating-lowlands-66736.herokuapp.com/packrat",
  TOKEN_KEY: "packrat-client-auth-token",
  API_KEY: process.env.REACT_APP_API_KEY,
};
